import axios from 'axios';

export default async path => {
  const response = await axios.get(path);
  return response.data;
};
